export default {
  // 是否支持requestIdleCallback api
  isSupportIdeCallback: !!window.requestIdleCallback,

  // 所有队列
  taskList: new Array([]),

  // 本轮长任务任务数
  count: 0,

  // 长队列执行完的对应图层render函数 Set会自动去重重复渲染函数
  renderFnSet: new Set([]),

  // 是否正在执行长任务
  isFlushLongTask: false,

  // 推入任务
  addTask(fn) {
    this.taskList.push(fn);
  },

  // 是否有任务
  get hasTask() {
    return this.taskList.length !== 0;
  },

  // 批量处理任务
  flushLongTask() {
    // 正常情况不兼容的浏览器 不会被推入长任务队列
    if (!this.isSupportIdeCallback) throw new Error('浏览器不支持requestIdleCallback 无法处理长任务');

    // 浏览器空闲时间片执行 不阻塞js线程 不会造成页面卡顿
    window.requestIdleCallback(deadline => {
      this.isFlushLongTask = true;

      while (
        deadline.timeRemaining() > 1 &&
        this.hasTask
      ) {
        // 有空闲时间片情况处理任务列表内容
        // 原则push 应从队头shift 但shift性能差 此处用pop有待验证？
        const task = this.taskList.pop();

        const renderFn = task instanceof Function && task();

        // 将执行完的t图层render函数推入set队列
        this.renderFnSet.add(renderFn);

        this.count++;
      }

      if (this.hasTask) {
        // 任务没有执行完 继续调用requestIdleCallback执行剩余任务
        this.flushLongTask();
      } else {
        // 首次清空完所有队列
        this.isFlushLongTask = false;

        console.log(`清空【 长任务 】队列, 总计【 ${this.count} 】个任务`);

        // 对长任务需要渲染的图层进行渲染
        if (this.renderFnSet.size !== 0) {
          this.renderFnSet.forEach(fn => fn && fn());
          this.renderFnSet.clear()
        }

         // 本轮计数结束
         this.count = 0;
      }
    });
  }
}